import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.0337 16.6854H7.61365C7.47364 16.6854 7.34375 16.6314 7.24365 16.5344C7.15368 16.4374 7.09375 16.3064 7.09375 16.1694V7.74937C7.09375 7.61337 7.15369 7.48137 7.24365 7.38538C7.34375 7.28838 7.47363 7.23438 7.61365 7.23438H16.0337C16.1737 7.23438 16.3037 7.28838 16.3937 7.38538C16.4937 7.48137 16.5437 7.61337 16.5437 7.74937V16.1694C16.5437 16.3064 16.4936 16.4374 16.3937 16.5344C16.3037 16.6314 16.1737 16.6854 16.0337 16.6854Z",
		stroke: "currentColor",
		strokeWidth: 1.35429,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.2546 7.23544V3.45445C12.2546 3.31744 12.2047 3.18643 12.1046 3.09044C12.0046 2.99344 11.8746 2.93945 11.7346 2.93945H3.3147C3.1847 2.93945 3.05469 2.99344 2.95471 3.09044C2.85461 3.18643 2.80469 3.31744 2.80469 3.45445V11.8745C2.80469 12.0114 2.85462 12.1424 2.95471 12.2394C3.05469 12.3355 3.18469 12.3904 3.3147 12.3904H7.09473",
		stroke: "currentColor",
		strokeWidth: 1.35429,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCopy;
